<template>
  <div class="bg-white border p-2 mt-3">
    <div class="table-responsive position-relative"
      :class="{ 'with-actions-gap': applicationProfiles.length < 4, 'opacity-50': loading }">
      <table class="table">
        <caption class="sr-only" data-no-export>{{ i18n('User profile grouped list') }}</caption>
        <thead>
          <tr class="d-none d-lg-table-row">
            <th scope="col">{{ i18n('Application') }}</th>
            <th scope="col">{{ i18n('Profiles') }}</th>
            <th scope="col">{{ i18n('Application Username') }}</th>
            <th data-no-export scope="col" style="min-width: 48px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <UserProfileGroupedListItem v-for="applicationProfile in applicationProfiles"
            :applicationProfile="applicationProfile" :key="applicationProfile.id" @deleted="$emit('deleted', $event)"
            @updated="$emit('updated', $event)" @updating="$emit('updating', $event)" :user="user"
            @showEditModal="showEditModal($event.user, $event.applicationProfile)"
            @editUsername="showUserApplicationUsernameModal($event.user, $event.applicationProfile.id)" />
          <EmptyListItem v-if="!applicationProfiles || applicationProfiles.length == 0" :loading="loading"
            :colspan="6 + ($root?.features?.applicationProfiles?.categories?.enabled ? 2 : 0)" />
          <LazyLoadListItem v-if="!loading && (lazyLoad || autoLazyLoad)"
            :autoLazyLoad="!pagination.singlePage && autoLazyLoad"
            :colspan="6 + ($root?.features?.applicationProfiles?.categories?.enabled ? 2 : 0)"
            @next="$emit('next', $event)" />
        </tbody>
      </table>
      <div class="position-absolute h-100 w-100 top-0" @click.stop v-if="loading"></div>
    </div>
  </div>

  <UserProfileGroupedModal ref="UserProfileGroupedModal" @setExpirations="$refs['UserProfileGroupedExpirationsModal'].show($event)" />
  <UserProfileGroupedExpirationsModal ref="UserProfileGroupedExpirationsModal" @updated="$emit('updated')" />
  <UserApplicationUsernameModal ref="UserApplicationUsernameModal" @updated="$emit('updated', $event)" />
</template>

<script>
import UserProfileGroupedListItem from "@/components/userProfile/UserProfileGroupedListItem.vue";
import EmptyListItem from "@/components/common/list/EmptyListItem.vue";
import LazyLoadListItem from "@/components/common/list/LazyLoadListItem.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";
import UserProfileGroupedModal from "@/components/userProfile/UserProfileGroupedModal.vue";
import UserProfileGroupedExpirationsModal from "@/components/userProfile/UserProfileGroupedExpirationsModal.vue";
import UserApplicationUsernameModal from "@/components/userApplicationUsername/UserApplicationUsernameModal.vue";

export default {
  components: {
    UserProfileGroupedListItem,
    EmptyListItem,
    LazyLoadListItem,
    Tooltip,
    UserProfileGroupedModal,
    UserProfileGroupedExpirationsModal,
    UserApplicationUsernameModal,
  },
  emits: [
    'deleted',
    'updated',
    'updating',
    'next',
    'goToPage',
  ],
  props: {
    loading: Boolean,
    lazyLoad: Boolean,
    autoLazyLoad: Boolean,
    applicationProfiles: {
      type: Array,
      default() {
        return [];
      },
    },
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showEditModal(user, applicationProfile) {
      this.$refs['UserProfileGroupedModal'].show(user, applicationProfile.id);
    },
    showUserApplicationUsernameModal(user, applicationId) {
      if (!this.$refs.UserApplicationUsernameModal) return;
      this.$refs.UserApplicationUsernameModal.show(user.id, applicationId);
    },
  },
};
</script>